import type { PropType } from 'virtual-vue';
import type { BadgeSize, BadgeShape, Offset } from './badge';

export const DEFAULT_BADGE_SIZE = 'small';
export const DEFAULT_BADGE_SHAPE = 'circle';
export const DEFAULT_BADGE_POSITION = 'right-top';

export const props = {
  /**
   * 尺寸
   * @default 'small'
   */
  size: {
    type: String as PropType<BadgeSize>,
    default: DEFAULT_BADGE_SIZE,
  },
  /**
   * 形状
   * @default 'circle'
   */
  shape: {
    type: String as PropType<BadgeShape>,
    default: DEFAULT_BADGE_SHAPE,
  },
  /**
   * 徽标中的文字
   */
  text: {
    type: String,
    default: '',
  },
  /**
   * 是否为红点
   */
  dot: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * 设置状态点的位置偏移
   */
  offset: {
    type: Array<string | number> as PropType<Offset>,
    default: () => [0, 0],
  },
};
